/**
 * RTX Subscription Dynamic Styling
 * Handles selected/unselected state classes for RTX subscription options
 * and updates add-to-cart button text
 */
class RTXSubscriptionStyling {
  constructor() {
    this.rtxContainer = null;
    this.subscriptionOption = null;
    this.oneTimeOption = null;
    this.subscriptionRadio = null;
    this.oneTimeRadio = null;
    this.addToCartButton = null;
  }

  init() {
    this.rtxContainer = document.querySelector('.rtx-buy-box-parent');
    if (!this.rtxContainer) return;

    this.subscriptionOption = this.rtxContainer.querySelector('.rtx_option_sub');
    this.oneTimeOption = this.rtxContainer.querySelector('.rtx_option_one_time');
    this.subscriptionRadio = this.rtxContainer.querySelector('input[value="subsave"]');
    this.oneTimeRadio = this.rtxContainer.querySelector('input[value="onetime"]');
    this.addToCartButton = document.querySelector('.main-cta-text');

    this.setupEventListeners();
    this.updateStyling();
  }

  setupEventListeners() {
    const radios = this.rtxContainer.querySelectorAll('input[name="selling_plan_select"]');
    
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        this.updateStyling();
      });
    });
  }

  updateStyling() {
    if (!this.subscriptionOption || !this.oneTimeOption) return;

    // Check which radio is selected
    const subscriptionSelected = this.subscriptionRadio?.checked;
    const oneTimeSelected = this.oneTimeRadio?.checked;

    // Update subscription option styling
    if (this.subscriptionOption) {
      if (subscriptionSelected) {
        this.subscriptionOption.classList.add('selected');
        this.subscriptionOption.classList.remove('unselected');
      } else {
        this.subscriptionOption.classList.add('unselected');
        this.subscriptionOption.classList.remove('selected');
      }
    }

    // Update one-time option styling
    if (this.oneTimeOption) {
      if (oneTimeSelected) {
        this.oneTimeOption.classList.add('selected');
        this.oneTimeOption.classList.remove('unselected');
      } else {
        this.oneTimeOption.classList.add('unselected');
        this.oneTimeOption.classList.remove('selected');
      }
    }

    // Update add-to-cart button text
    this.updateButtonText(subscriptionSelected, oneTimeSelected);
  }

  updateButtonText(subscriptionSelected, oneTimeSelected) {
    if (!this.addToCartButton) return;

    if (subscriptionSelected) {
      this.addToCartButton.textContent = 'Subscribe';
    } else if (oneTimeSelected) {
      this.addToCartButton.textContent = 'Add to Bag';
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const rtxStyling = new RTXSubscriptionStyling();
  rtxStyling.init();
});

// Also initialize if DOM is already loaded (for dynamic content)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const rtxStyling = new RTXSubscriptionStyling();
    rtxStyling.init();
  });
} else {
  const rtxStyling = new RTXSubscriptionStyling();
  rtxStyling.init();
}